export default "__VITE_ASSET__B1lwj2YB__"